import { numberComplete } from '@/utils'
const config = {
  type: "gauge",
  startAngle: 208,
  endAngle: 170,
  radius: "86%",
  center: ["50%", "60%"],
  min: 0,
  max: 300,
  splitNumber: 1,
  animation: !0,
  progress: {
    show: !1,
    width: 18
  },
  axisLine: {
    show: !1
  },
  pointer: {
    show: !0,
    length: 90,
    offsetCenter: [0, 16],
    icon: "image://data:image/png;base64,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",
    width: 90
  },
  axisTick: {
    show: !1
  },
  splitLine: {
    show: !1
  },
  axisLabel: {
    show: !1
  },
  title: {
    show: !1
  },
  detail: {
    show: !1
  }
}
export function gaugeChart(data) {
  return {
    series: [{
      ...config,
      pointer: {
        ...config.pointer,
        show: data <= 300
      },
      detail: {
        fontSize: 24,
        offsetCenter: [0, "50"],
        valueAnimation: !0,
        formatter: function (t) {
          return Math.round(t) + ""
        },
        color: "#1D2129"
      },
      title: {
        offsetCenter: [0, "74"],
        fontSize: 12
      },
      data: [{
        value: data,
        name: "综合评分"
      }]
    },
    {
      ...config,
      startAngle: 170,
      endAngle: 120,
      min: 300,
      max: 320,
      splitNumber: 1,
      pointer: {
        ...config.pointer,
        show: data <= 320 && data > 300
      },
      data: [{
        value: data,
        name: "综合评分"
      }]
    },
    {
      ...config,
      startAngle: 120,
      endAngle: 72,
      min: 320,
      max: 350,
      splitNumber: 1,
      pointer: {
        ...config.pointer,
        show: data <= 350 && data > 320
      },
      data: [{
        value: data,
        name: "综合评分"
      }]
    },
    {
      ...config,
      startAngle: 72,
      endAngle: 10,
      min: 350,
      max: 400,
      splitNumber: 1,
      pointer: {
        ...config.pointer,
        show: data <= 400 && data > 350
      },
      data: [{
        value: data,
        name: "综合评分"
      }]
    },
    {
      ...config,
      startAngle: 10,
      endAngle: 338,
      min: 400,
      max: 600,
      splitNumber: 1,
      pointer: {
        ...config.pointer,
        show: data > 400
      },
      data: [{
        value: data,
        name: "综合评分"
      }]
    }]
  }
}

export function scienceChart(data) {
  return {
    series: [
      {
        ...config,
        startAngle: 216,
        endAngle: 150,
        pointer: {
          ...config.pointer,
          show: data <= 300 // E
        },
        data: [{
          value: data,
          name: "科创评分"
        }]
      },
      {
        ...config,
        startAngle: 170,
        endAngle: 120,
        min: 300,
        max: 320,
        splitNumber: 1,
        pointer: {
          ...config.pointer,
          show: data <= 320 && data > 300
        },
        data: [{
          value: data,
          name: "科创评分"
        }]
      },
      {
        ...config,
        startAngle: 120,
        endAngle: 72,
        min: 320,
        max: 350,
        splitNumber: 1,
        pointer: {
          ...config.pointer,
          show: data <= 350 && data > 320
        },
        data: [{
          value: data,
          name: "科创评分"
        }]
      },
      {
        ...config,
        startAngle: 72,
        endAngle: 10,
        min: 350,
        max: 400,
        splitNumber: 1,
        pointer: {
          ...config.pointer,
          show: data <= 400 && data > 350
        },
        data: [{
          value: data,
          name: "科创评分"
        }]
      },
      {
        ...config,
        startAngle: 10,
        endAngle: 338,
        min: 400,
        max: 600,
        splitNumber: 1,
        pointer: {
          ...config.pointer,
          show: data > 400
        },
        detail: {
          fontSize: 24,
          offsetCenter: [0, "50"],
          valueAnimation: !0,
          formatter: function (t) {
            return Math.round(t) + ""
          },
          color: "#1D2129"
        },
        title: {
          offsetCenter: [0, "74"],
          fontSize: 12
        },
        data: [{
          value: data,
          name: "科创评分"
        }]
      }
    ]
  }
  return {
    series: [{
      ...config,
      pointer: {
        ...config.pointer,
        show: data <= 300
      },
      detail: {
        fontSize: 24,
        offsetCenter: [0, "50"],
        valueAnimation: !0,
        formatter: function (t) {
          return Math.round(t) + ""
        },
        color: "#1D2129"
      },
      title: {
        offsetCenter: [0, "74"],
        fontSize: 12
      },
      data: [{
        value: data,
        name: "科创评分"
      }]
    },
    {
      ...config,
      startAngle: 170,
      endAngle: 120,
      min: 300,
      max: 320,
      splitNumber: 1,
      pointer: {
        ...config.pointer,
        show: data <= 320 && data > 300
      },
      data: [{
        value: data,
        name: "科创评分"
      }]
    },
    {
      ...config,
      startAngle: 120,
      endAngle: 72,
      min: 320,
      max: 350,
      splitNumber: 1,
      pointer: {
        ...config.pointer,
        show: data <= 350 && data > 320
      },
      data: [{
        value: data,
        name: "科创评分"
      }]
    },
    {
      ...config,
      startAngle: 72,
      endAngle: 10,
      min: 350,
      max: 400,
      splitNumber: 1,
      pointer: {
        ...config.pointer,
        show: data <= 400 && data > 350
      },
      data: [{
        value: data,
        name: "科创评分"
      }]
    },
    {
      ...config,
      startAngle: 10,
      endAngle: 338,
      min: 400,
      max: 600,
      splitNumber: 1,
      pointer: {
        ...config.pointer,
        show: data > 400
      },
      data: [{
        value: data,
        name: "科创评分"
      }]
    }]
  }
}




export function industryRadar(t) {
  return {
    colorBy: "data",
    color: t.map((t => t.color)),
    legend: {
      data: t.map((t => t.name)),
      right: '0',
      top: 'center',
      orient: 'vertical'
    },
    radar: {
      indicator: [
        {
          "name": "知识产权",
          "max": 100
        },
        {
          "name": "科技资质",
          "max": 100
        },
        {
          "name": "研发能力",
          "max": 100
        },
        // {
        //   "name": "行业发展",
        //   "max": 100
        // },
        {
          "name": "成长潜力",
          "max": 100
        },
        {
          "name": "财税规模",
          "max": 100
        },
        {
          "name": "履约信用",
          "max": 100
        }
      ]
    },
    series: [{
      name: "subEvaluation",
      type: "radar",
      symbolSize: 0,
      symbolKeepAspect: !0,
      areaStyle: {
        opacity: .1
      },
      data: t
    }]
  }

}